module.exports = __webpack_public_path__ + "img/paul_n_2.cd737c52.png";